import { makeStyles, createStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      display: "flex",
      minHeight: 500,
      "& .MuiDataGrid-columnHeaderWrapper": {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      },
      "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": {
        color: "rgba(255,255,255,1)",
      },
    },
    swipeableDrawer: {
      width: "auto",
      marginTop: "80",
      height: "100%",
    },
    CustomMuiDrawer: {
      "& .MuiDrawer-paper": {
        top: "64px",
        height: "calc(100% - 64px)",
      },
    },
    fullList: {
      width: "auto",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    stickyBlock: {
      zIndex: 10,
      position: "sticky",
      top: "64px",
      height: "120px",
      padding: "10px",
      backgroundColor: "#f6f6f6",
      boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%)",
      display: "none",
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },

    closeDrawer: {
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: theme.typography.pxToRem(24),
      padding: "0px 8px",
      minWidth: "35px",
    },
    drawerHeader: {
      marginTop: "15px",
      borderBottom: "1px solid #d8c2c2",
      marginBottom: "15px",
      "& .icon": { marginLeft: "10px" },
      "& .MuiSvgIcon-root": { cursor: "pointer", fontSize: "medium", color: "#488CFB" },
    },
    drawerHeaderWithoutBorder: {
      marginTop: "15px",
      marginBottom: "15px",
      "& .icon": { marginLeft: "10px" },
      "& .MuiSvgIcon-root": { cursor: "pointer", fontSize: "medium", color: "#488CFB" },
    },
    icon: {
      "& .MuiSvgIcon-root": { cursor: "auto", color: "black", fontSize: "18px" },
    },
  })
);
